import { useState, useEffect } from 'react';

export const useIsMobile = (mobileWidth = 768) => {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      // Safe to use window after component has mounted
      const checkMobile = () => {
        setIsMobile(window.innerWidth <= mobileWidth);
      };

      checkMobile(); // Set initial value

      const handleResize = (() => {
        let timeout: NodeJS.Timeout;
        return () => {
          clearTimeout(timeout);
          timeout = setTimeout(checkMobile, 300);
        };
      })();

      window.addEventListener('resize', handleResize);

      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }
  }, [mobileWidth]);

  return isMobile;
};
